export default "__VITE_ASSET__BOnd7HVQ__"